
(function() {
  const initBubbleSlider = () => {
    const bubble_sliders = document.querySelectorAll('.carousel__slider-sus-bubbles');
    bubble_sliders.forEach((slider, index) => {

      const bubbleSlider = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        watchSlidesProgress: true,
        simulateTouch: true, 
        autoHeight: false,
        speed: 500,
        breakpoints: {
              576: {
                spaceBetween: 14,
              },
              990: {
                spaceBetween: 26,
              },
            },
        navigation: {
          nextEl: ".carousel__slider-nav .swiper-button-next",
          prevEl: ".carousel__slider-nav .swiper-button-prev",
        }
      })
    })
  }
  initBubbleSlider();
})()